$(document).ready(function() {

  console.log("collection slider is running");
  var TotalSlideNum = 5;    
  $('#goddess_slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 500,
      pauseOnHover: false,
      cssEase: 'linear',
       responsive: [
    {
      // tablet
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
          slidesToScroll: 3
      }
    },
    {
      // mobile portrait
      breakpoint: 759,
      settings: {
        slidesToShow: 1,
          slidesToScroll: 1,
        infinite: false
      }
    }]
    });

    $('#goddess_yt').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 500,
      pauseOnHover: false,
      cssEase: 'linear'
    });

  $('input[type="radio"]').click(function(){
        var inputValue = $(this).attr("value");
        var targetBox = $("#cyberdoll-" + inputValue);
        $(".description").not(targetBox).hide();
        $(targetBox).show();
    });  
   
    $(".btnprev").click(function(){
       var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
       var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
       console.log("on slideNum", slideNum)
        if (slideNum > 1 && slideNum <= 8){
            var cslideNum  = slideNum - 1  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#cyberdoll-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        
        }else if (slideNum == 1 ){
            var cslideNum  = 8  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);
            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#cyberdoll-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });
    $(".btnnext").click(function(){
        var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
        var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
     
       console.log("on slideNum", slideNum)
        if (slideNum > 0 && slideNum < 8){
            var cslideNum  = slideNum + 1 ;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#cyberdoll-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        }else if (slideNum = TotalSlideNum ){
            var cslideNum  = 1;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#cyberdoll-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });


var prev = document.getElementsByClassName('slick-prev');
var next = document.getElementsByClassName('slick-next');
console.log("prev", prev);
  console.log("next", next);
  if(prev.length > 0){
    document.getElementsByClassName('slick-prev')[0].innerHTML = "<button aria-label=\"button\" class=\"slick-prev button button--style2 button--circle lh1 slick-arrow\"><span></span></button>";
  }

  if(next.length > 0){
      document.getElementsByClassName('slick-next')[0].innerHTML = "<button aria-label=\"button\" class=\"slick-next button button--style2 button--circle lh1 slick-arrow\" style=\"border\"><span></span></button>";
  }
})

